<template>
  <div>
    <!-- Footer removido -->
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>
